import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const translateTemplateStyle: StyleRulesCallback = () => ({
  stagesContainer: {
    marginTop: '20px',
  },
});

export default translateTemplateStyle;